import { ModelListsService } from './modelListsService';
import { AIModel } from '../types';

/**
 * @deprecated Use ModelListsService.getTopModels() directly
 * This service is maintained for backwards compatibility
 */
export class TopModelsService {
  /**
   * Fetch all top models from Firestore (up to 10)
   * These are updated daily by the scheduled Cloud Function
   * Now delegates to ModelListsService for the new structure
   */
  static async getTopModels(): Promise<AIModel[]> {
    try {
      console.log('🔍 Fetching all top models from Firestore...');

      const allModels = await ModelListsService.getTopModels();
      
      // Return all models (up to 10)
      console.log(`🎯 Loaded all ${allModels.length} models:`, allModels.map((m: AIModel) => ({
        name: m.name,
        creator: m.modelCreator,
        intelligenceIndex: m.intelligenceIndex,
        openrouterId: m.openrouterId,
      })));

      return allModels;
    } catch (error) {
      console.error('❌ Error fetching top models from Firestore:', error);
      throw error;
    }
  }
}

